import { AST } from '@handlebars/parser';
import { isStringLiteral } from 'modules/handlebars/domain/literal/utils';
import { isDefined } from 'utils/tsHelpers';

export const getSnippetNameFromMustacheStatement = (
  snippetStatement: AST.MustacheStatement | null,
) => {
  const [snippetNameParam] = snippetStatement?.params ?? [];
  return isDefined(snippetNameParam) && isStringLiteral(snippetNameParam)
    ? snippetNameParam.value
    : null;
};
